<template>
  <div>
    <div class="ceNav">
      <ul>
        <li>
          <a href="javascript:" onclick="javascript:window.open('https://url.cn/xhfZSoT6?_type=wpa&qidian=true', '_blank', 'height=544, width=644,toolbar=no,scrollbars=no,menubar=no,status=no');">
            <span class="iconfont icon-qq"></span>
            <i>QQ客服</i>
          </a>
        </li>
        <li>
          <a href="javascript:" target="_blank">
            <span class="iconfont icon-dianhua"></span>
            <i>400电话</i>
          </a>
          <div class="ceNav-con">
            <p>给我们拨打电话<b>400 920 9933</b></p>
          </div>
        </li>
        <li>
          <a href="javascript:" target="_blank">
            <span class="iconfont icon-erweima"></span>
            <i>微信</i>
          </a>
          <div class="ceNav-con">
            <img src="https://www.sitestar.cn/images/qyCode.png">
          </div>
        </li>
      </ul>  
    </div>

    <!-- [优化] 手机端底部转化栏：电话 / 微信 / 留言 / 免费建站（替代原两按钮栏） -->
    <nav class="mbar" v-if="isMobile" aria-label="快捷联系">
      <a href="tel:4009209933" class="mbar-i">
        <span class="iconfont icon-dianhua"></span><span>电话</span>
      </a>
      <a href="https://wpa1.qq.com/6vqZlhVX?_type=wpa&qidian=true" class="mbar-i" target="_blank">
        <span class="iconfont icon-erweima"></span><span>微信</span>
      </a>
      <a href="javascript:" class="mbar-i" @click="goLead()">
        <i class="bi bi-chat-dots"></i><span>留言</span>
      </a>
      <a href="javascript:" class="mbar-free" @click="actionFree()">免费建站</a>
    </nav>

    <div class="wxModal" v-if="wxOpen" @click.self="wxOpen = false" role="dialog" aria-label="微信咨询">
      <div class="wxModal-box">
        <button type="button" class="wxModal-x" @click="wxOpen = false" aria-label="关闭">×</button>
        <p class="wxModal-t">微信扫码咨询</p>
        <img src="https://www.sitestar.cn/images/qyCode.png" alt="建站之星企业微信二维码" width="200" height="200">
        <p class="wxModal-d">截图保存后在微信中识别，或</p>
        <a class="wxModal-btn" href="https://ichat.meicheng.top/kf.php?mod=client&cid=800015083&wid=random&code=d96f8b3d360b331e382c694aee934f73&mb=1">在线客服咨询</a>
      </div>
    </div>
  </div>
  
</template>

<script>
import deviceMixin from '@/mixins/device';
export default {
  mixins: [deviceMixin],
  data () {
    return {
      wxOpen: false,
      // mckeyword:window.localStorage.getItem("mckeyword"),
      //mckeyword:this.$cookies.get('mckeyword'),

    }
  },
  mounted(){
    document.body.classList.add('has-mbar');
  },
  beforeDestroy(){
    document.body.classList.remove('has-mbar');
  },
  methods:{
    // 留言：当前页有留言表单（Footer #lead）则滚动过去；否则回首页定位
    goLead(){
      const el = document.getElementById('lead');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        this.$router.push({ path: '/', hash: '#lead' });
      }
    },
    goToRegister() {
      const b = sessionStorage.getItem('param_b');
      const targetUrl = b ? `https://www.sitestar.cn/member/register.aspx?b=${encodeURIComponent(b)}` 
                          : 'https://www.sitestar.cn/member/register.aspx';
      window.location.href = targetUrl;
    },

    actionFree(){
       this.$router.push({ path: '/templates', query: { serviceType:'free'} })
    }
  }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mbar{ display:flex; position:fixed; left:0; right:0; bottom:0; z-index:900; height:60px; background:#fff; box-shadow:0 -2px 10px rgba(0,0,0,.1); padding-bottom:env(safe-area-inset-bottom); }
  .mbar-i{ flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:2px; color:#333; font-size:13px; text-decoration:none; }
  .mbar-i .iconfont, .mbar-i .bi{ font-size:20px; color:#1a7fe0; line-height:1; }
  .mbar-free{ flex:1.6; display:flex; align-items:center; justify-content:center; background:#1a7fe0; color:#fff; font-size:17px; font-weight:bold; text-decoration:none; }
  .wxModal{ position:fixed; inset:0; z-index:1000; background:rgba(0,0,0,.55); display:flex; align-items:center; justify-content:center; padding:20px; }
  .wxModal-box{ position:relative; background:#fff; border-radius:14px; padding:26px 24px 22px; width:100%; max-width:300px; text-align:center; }
  .wxModal-box img{ width:200px; height:200px; display:block; margin:10px auto; }
  .wxModal-t{ font-size:18px; font-weight:bold; margin:0; }
  .wxModal-d{ font-size:14px; color:#666; margin:0 0 10px; }
  .wxModal-x{ position:absolute; right:6px; top:4px; width:44px; height:44px; border:0; background:none; font-size:28px; color:#999; }
  .wxModal-btn{ display:flex; align-items:center; justify-content:center; min-height:46px; border-radius:999px; background:#1a7fe0; color:#fff; font-size:16px; text-decoration:none; }
</style>



// WEBPACK FOOTER //
// src/components/ceNav.vue